module.exports = __webpack_public_path__ + "img/d17.42f19083.png";